import MainRoutes from '@/router/MainRoutes';
import _ from 'lodash';
import { store, key } from '@/storeVuex';
import HomeIcon from '@/layouts/full/vertical-sidebar/Icons/HomeIcon.vue';
import EstimatesIcon from '@/layouts/full/vertical-sidebar/Icons/EstimatesIcon.vue';
import ProjectsIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectsIcon.vue';
import SchedulesIcon from '@/layouts/full/vertical-sidebar/Icons/SchedulesIcon.vue';
import ProjectNotesIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectNotesIcon.vue';
import StorageIcon from '@/layouts/full/vertical-sidebar/Icons/StorageIcon.vue';
import InternalUsersIcon from '@/layouts/full/vertical-sidebar/Icons/InternalUsersIcon.vue';
import CustomersIcon from '@/layouts/full/vertical-sidebar/Icons/CustomersIcon.vue';
import ManageRolesIcon from '@/layouts/full/vertical-sidebar/Icons/ManageRolesIcon.vue';
import CalculatorIcon from '@/layouts/full/vertical-sidebar/Icons/CalculatorIcon.vue';
import NCCIcon from '@/layouts/full/vertical-sidebar/Icons/NCCIcon.vue';
import TimeTrackerIcon from '@/layouts/full/vertical-sidebar/Icons/TimeTrackerIcon.vue';
import SupplierIcon from '@/layouts/full/vertical-sidebar/Icons/SupplierIcon.vue';
import EquipmentIcon from '@/layouts/full/vertical-sidebar/Icons/EquipmentIcon.vue';
import BulkImportIcon from '@/layouts/full/vertical-sidebar/Icons/BulkImportIcon.vue';
import ProjectSettingsIcon from '@/layouts/full/vertical-sidebar/Icons/ProjectSettingsIcon.vue';
import {
    DashboardIcon,
    CalendarCheckIcon,
    ListDetailsIcon,
    CardboardsIcon,
    ApertureIcon,
    CalendarTimeIcon,
    UserIcon,
    BoxSeamIcon,
    BuildingIcon,
    UserStarIcon,
    BoxIcon,
    SettingsCodeIcon,
    RulerIcon,
    FilePlusIcon,
    AlertTriangleIcon,
    FileDescriptionIcon,
    ShieldCheckIcon
} from 'vue-tabler-icons';

export interface menu {
    header?: string;
    ispage?: boolean;
    title?: string;
    icon?: any;
    isusertype?: any;
    to?: string;
    chip?: string;
    chipBgColor?: string;
    chipColor?: string;
    chipVariant?: string;
    chipIcon?: string;
    children?: menu[];
    child?: any;
    disabled?: boolean;
    type?: string;
    subCaption?: string;
    isPage?: boolean;
    proj_manage?: any;
    isrole?: any;
    // Plan-gate key (see stores/planAccess.ts::isAllowed). NavItem renders
    // a lock + Upgrade chip when the user's plan lacks this feature.
    requiresPlanFeature?: string;
    // Runtime feature-flag key (see stores/featureFlags). Hidden per-environment
    // when this key is in the backend's HIDDEN_FEATURES.
    featureKey?: string;
}

function mRoute(val) {
    const index = _.findLastIndex(MainRoutes.children, function (chr) {
        return chr.name == val;
    });
    return MainRoutes.children[index];
}
// function checkrole(val){
//    if(store.state.user.user){
//       let concat = val + '__View';
//          if(store.state.user.user.roles[concat] != undefined){
//            return store.state.user.user.roles[concat];
//          }else{
//            return null;
//          }
//     };
// }

const sidebarItem: menu[] = [
    //   { header: 'Home',ispage:false,child:['dashboard'] },
    {
        title: mRoute('dashboard').meta.title,
        to: mRoute('dashboard').name,
        icon: HomeIcon,
        isPage: mRoute('dashboard').isPage
    },
    {
        title: mRoute('build_board')?.meta?.title || 'Build Board',
        to: mRoute('build_board')?.name,
        icon: ListDetailsIcon,
        isPage: mRoute('build_board')?.isPage
    },
    { header: 'Project Management', ispage: true, proj_manage: 'proj_manage', child: ['jobs', 'notes', 'estimate'] },
    //   {
    //      title: mRoute('jobs_sub').meta.title,
    //      to: mRoute('jobs_sub').name,
    //      icon: CalendarCheckIcon,
    //      isPage: mRoute('jobs_sub').isPage,
    //      proj_manage:'subvendor',
    //   },
    {
        title: mRoute('jobs').meta.title,
        to: mRoute('jobs').name,
        icon: ProjectsIcon,
        isPage: mRoute('jobs').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'projects'
    },
    {
        title: mRoute('estimates').meta.title,
        to: mRoute('estimates').name,
        icon: EstimatesIcon,
        isPage: mRoute('estimates').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'estimates'
    },
    {
        title: mRoute('schedules').meta.title,
        to: mRoute('schedules').name,
        icon: SchedulesIcon,
        isPage: mRoute('schedules').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'scheduling'
    },
    {
        title: mRoute('client_portal').meta.title,
        to: mRoute('client_portal').name,
        icon: FileDescriptionIcon,
        isPage: mRoute('client_portal').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'quotes',
        featureKey: 'quotes'
    },
    {
        title: mRoute('team_tracker').meta.title,
        to: mRoute('team_tracker').name,
        icon: TimeTrackerIcon,
        isPage: mRoute('team_tracker').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'crew_tracker'
    },
    // {
    //     title: mRoute('equipment_tracker').meta.title,
    //     to: mRoute('equipment_tracker').name,
    //     icon: EquipmentIcon,
    //     isPage: mRoute('equipment_tracker').isPage,
    //     proj_manage: 'proj_manage'
    // },
    {
        title: mRoute('notes').meta.title,
        to: mRoute('notes').name,
        icon: ProjectNotesIcon,
        isPage: mRoute('notes').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('file_manager').meta.title,
        to: mRoute('file_manager').name,
        icon: StorageIcon,
        isPage: mRoute('file_manager').isPage,
        proj_manage: 'proj_manage',
        requiresPlanFeature: 'storage'
    },
    {
        title: mRoute('calculator').meta.title,
        to: mRoute('calculator').name,
        icon: CalculatorIcon,
        isPage: mRoute('calculator').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('ncc_assistant').meta.title,
        to: mRoute('ncc_assistant').name,
        icon: NCCIcon,
        isPage: mRoute('ncc_assistant').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('ncc_details').meta.title,
        to: mRoute('ncc_details').name,
        icon: NCCIcon,
        isPage: mRoute('ncc_details').isPage,
        proj_manage: 'proj_manage'
    },
    {
        title: mRoute('ncc_reference').meta.title,
        to: mRoute('ncc_reference').name,
        icon: NCCIcon,
        isPage: mRoute('ncc_reference').isPage,
        proj_manage: 'proj_manage'
    },
    // {
    //     title: mRoute('equipments').meta.title,
    //     to: mRoute('equipments').name,
    //     icon: EquipmentIcon,
    //     isPage: mRoute('equipments').isPage,
    //     proj_manage: 'proj_manage'
    // },
    { header: 'OHS', ispage: true, proj_manage: 'ohs', child: ['ohs'] },
    {
        title: mRoute('ohs').meta.title,
        to: mRoute('ohs').name,
        icon: ShieldCheckIcon,
        isPage: mRoute('ohs').isPage,
        proj_manage: 'ohs'
    },
    {
        header: 'User Management',
        isusertype: 1,
        ispage: true,
        proj_manage: 'user_management',
        child: ['internal_users', 'customers', 'suppliers', 'user_roles', 'equipments', 'bulk_import']
    },
    {
        title: mRoute('internal_users').meta.title,
        to: mRoute('internal_users').name,
        icon: InternalUsersIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('internal_users').isPage
    },
    {
        title: mRoute('equipments').meta.title,
        to: mRoute('equipments').name,
        icon: EquipmentIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('equipments').isPage
    },
    {
        title: mRoute('customers').meta.title,
        to: mRoute('customers').name,
        icon: CustomersIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('customers').isPage
    },
    {
        title: mRoute('suppliers').meta.title,
        to: mRoute('suppliers').name,
        icon: SupplierIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('suppliers').isPage
    },
    {
        title: mRoute('user_roles').meta.title,
        to: mRoute('user_roles').name,
        icon: ManageRolesIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('user_roles').isPage
    },
    {
        title: mRoute('bulk_import').meta.title,
        to: mRoute('bulk_import').name,
        icon: BulkImportIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('bulk_import').isPage
    },
    { header: 'Integrations', isusertype: 1, ispage: true, proj_manage: 'user_management', child: ['developer_portal'] },
    {
        title: mRoute('developer_portal').meta.title,
        to: mRoute('developer_portal').name,
        icon: SettingsCodeIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('developer_portal').isPage
    },
    { header: 'Admin Insights', isusertype: 1, ispage: true, proj_manage: 'user_management', child: ['at_risk_trials'] },
    {
        title: mRoute('at_risk_trials').meta.title,
        to: mRoute('at_risk_trials').name,
        icon: AlertTriangleIcon,
        isusertype: 1,
        proj_manage: 'user_management',
        isPage: mRoute('at_risk_trials').isPage
    }
];

export default sidebarItem;
